import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { Apps, BtnLogin, BtnRegister, Chars, Logo } from "src/assets";
import { FloatingBanner } from "src/main/components";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.container}>
      <Box sx={styles.root}>
        <VisuallyHidden as="h1">W268</VisuallyHidden>
        <Stack
          direction="column"
          alignItems="center"
          width="100%"
          textAlign="center"
        >
          <img
            alt="logo"
            src={Logo}
            style={{ width: 270, marginTop: 4 }}
          />

          <Stack
            direction="row"
            gap={1.5}
            mt={2.5}
          >
            <a
              href={loginUrl}
              onClick={handleClick("login")}
              target="_blank"
              rel="noreferrer"
            >
              <img
                alt="btn-login"
                src={BtnLogin}
                style={{ width: 146 }}
              />
            </a>
            <a
              href={registerUrl}
              onClick={handleClick("register")}
              target="_blank"
              rel="noreferrer"
            >
              <img
                alt="btn-register"
                src={BtnRegister}
                style={{ width: 146 }}
              />
            </a>
          </Stack>

          <img
            alt="chars"
            src={Chars}
            style={{ width: 360, marginTop: 40 }}
          />

          <img
            alt="apps"
            src={Apps}
            style={{ width: 234, marginTop: -122, paddingBottom: 76 }}
          />
        </Stack>

        <FloatingBanner />
      </Box>
    </Box>
  );
};

const styles = createStyles({
  container: {
    textAlign: "center",
  },
  root: {
    p: "16px",
    pb: "0px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
  images: {
    zIndex: 10,
    position: "relative",
    width: "360px",
    height: "324px",
    img: {
      position: "absolute",
    },
  },
  footer: {
    zIndex: 0,
    position: "fixed",
    bottom: "0",
    width: "100vw",
    height: "200px",
    flexShrink: 0,
    background: "radial-gradient(800px 100% at 50% 100%, #FFF9C1 0%, #21966C 19%, rgba(0, 0, 0, 0.00) 50%)",
  },
});

export default LandingPage;
